import { createReducer, on } from '@ngrx/store';
import { initialAuthState } from './auth.state';
import * as AuthActions from './auth.actions';

export const authReducer = createReducer(
  initialAuthState,

  // Login
  on(AuthActions.login, (state) => ({ ...state, isLoading: true, error: null })),
  on(AuthActions.loginFailure, (state, { error }) => ({ ...state, isLoading: false, error })),
  on(AuthActions.setMenus, (state, { menus }) => ({
    ...state,
    menus: menus,
  })),

  // Logout
  on(AuthActions.logout, (state) => ({ ...state, isLoading: true })),
  on(AuthActions.logoutSuccess, () => ({ ...initialAuthState })),

  // Permissions
  on(AuthActions.loadPermissions, (state) => ({ ...state, isLoading: true })),
  on(AuthActions.loadPermissionsSuccess, (state, { permissions }) => ({
    ...state,
    permissions,
    isLoading: false,
  })),
  on(AuthActions.loadPermissionsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Initialize & Utility
  on(AuthActions.setAuthUserFromStorage, (state, { user }) => ({
    ...state,
    currentUser: user,
    isAuthenticated: true,
  })),

  on(AuthActions.setAccessTokenToStore, (state, { access_token }) => ({
    ...state,
    access_token: access_token,
  })),

  // Refresh User Info
  on(AuthActions.refreshUserInfo, (state) => ({ ...state, isLoading: true, error: null })),
  on(AuthActions.refreshUserInfoSuccess, (state, { user, menus, functions }) => ({
    ...state,
    currentUser: user,
    menus: menus,
    permissions: functions,
    isAuthenticated: true,
    isLoading: false,
    error: null,
  })),

  on(AuthActions.setLoading, (state, { isLoading }) => ({ ...state, isLoading })),
  on(AuthActions.clearError, (state) => ({ ...state, error: null })),
);
